import { lazy, Suspense } from 'react';

// Lazy load the heavy TradingView component
const TradingView = lazy(() => import('./tv-chart'));

// Loading placeholder for better perceived performance
export const ChartLoader = () => (
  <div className="flex h-full w-full flex-1 items-center justify-center bg-background md:min-h-[400px]">
    <div className="flex flex-col items-center gap-4">
      <div className="relative">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-border border-t-primary"></div>
        <div className="absolute inset-0 h-12 w-12 animate-ping rounded-full border-2 border-primary opacity-20"></div>
      </div>
      <p className="font-mono text-sm text-muted-foreground">
        Loading chart...
      </p>
    </div>
  </div>
);

export default function LazyTradingView() {
  return (
    <Suspense fallback={<ChartLoader />}>
      <TradingView />
    </Suspense>
  );
}
